import { List, ListItemButton, ListItemText } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppDialog } from "../dialog/app-dialog.component";
import { IGroupContract } from "../../domain/group/group-contract";
import { formatDateShort } from "../../utils/date.util";

interface IPomContractSelectionDialogProps {
  open: boolean;
  contracts: IGroupContract[];
  onContractSelected: (contractNumber: string) => void;
  onCancel?: () => void;
}

export const PomContractSelectionDialog: FC<IPomContractSelectionDialogProps> = (props) => {
  const { open, contracts, onContractSelected, onCancel } = props;
  const { t } = useTranslation();

  return (
    <AppDialog
      open={open}
      title={t("pom.reportings.contract_selection.title")}
      isAcceptVisible={false}
      onCancelClick={onCancel}
      alignButtons="space-between"
      maxWidth="sm"
    >
      <List>
        {contracts.map((contract) => (
          <ListItemButton key={contract.contractNumber} onClick={() => onContractSelected(contract.contractNumber)}>
            <ListItemText
              primary={contract.contractNumber}
              secondary={
                contract.takeBackSystemName
                  ? `${contract.takeBackSystemName} – ${formatDateShort(contract.startDate)}`
                  : formatDateShort(contract.startDate)
              }
            />
          </ListItemButton>
        ))}
      </List>
    </AppDialog>
  );
};
